import { Detail } from "../models/detail";
import { DetailGroupPack } from "../models/detail-group-pack";
import { MenuItem } from "../models/menu-item";

export class MenuItemHolder 
{
    constructor(){}

    public MenuItem:MenuItem = new MenuItem();
    public DetailGroupPacks:Array<DetailGroupPack> = new Array(); 

    public get ID()
    {
        return this.MenuItem.ID;
    }

    public get UniversalID()
    {
        return this.MenuItem.UniversalID;
    }

    public get Name()
    {
        var name = this.MenuItem.Name;

        if(name.length > 25)
            return name.substring(0, 25) + '...';

        return name;
    }

    public get CountName()
    {
        return `${this.MenuItem.ItemCount} ${this.MenuItem.Name}`;
    }

    public get Picture()
    {
        return this.MenuItem.Picture;
    }

    public get CurrentIndividualAddtionalPrice()
    {
        let currentAdditionalPrice = 0.0;

        for (let index = 0; index < this.DetailGroupPacks.length; index++) 
        {
            const detailGroupPack = this.DetailGroupPacks[index];
            
            currentAdditionalPrice += detailGroupPack.getCurrentPrice();
        }

        return currentAdditionalPrice;
    }

    public get CurrentAddtionalPrice()
    {
        let currentAdditionalPrice = 0.0;

        for (let index = 0; index < this.DetailGroupPacks.length; index++) 
        {
            const detailGroupPack = this.DetailGroupPacks[index];
            
            currentAdditionalPrice += detailGroupPack.getCurrentPrice();
        }

        return currentAdditionalPrice * this.MenuItem.ItemCount;
    }

    public get CurrentComboPrice()
    {
        let currentComboPrice = this.MenuItem.ComboPrice;

        for (let index = 0; index < this.DetailGroupPacks.length; index++) 
        {
            const detailGroupPack = this.DetailGroupPacks[index];
            
            currentComboPrice += detailGroupPack.getCurrentPrice();
        }

        return currentComboPrice * this.MenuItem.ItemCount;
    }

    public get CurrentIndividualPrice()
    {
        return this.MenuItem.DefaultPrice + this.CurrentIndividualAddtionalPrice;
    }

    public get CurrentPrice()
    {
        return this.CurrentIndividualPrice * this.MenuItem.ItemCount;
    }

    public get Summary()
    {
        var text = "";

        if (this.MenuItem.DetailGroups !== null && this.MenuItem.DetailGroups !== undefined && this.MenuItem.DetailGroups.length > 0)
        {
            text = "";

            var lines = new Array<string>();

            var details = new Array<Detail>();

            for (let index = 0; index < this.DetailGroupPacks.length; index++) 
            {
                const detailGroupPack = this.DetailGroupPacks[index];
                
                for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
                {
                    const detail = detailGroupPack.DetailList[index];
                    
                    if(detail.CurrentCount > 0)
                        details.push(detail);
                }
            }

            for (let index = 0; index < details.length; index++) 
            {
                const detail = details[index];
                
                lines.push(`${detail.Type == 0 ? "+" : ">"}${detail.PrintName}`);
            }

            if (this.MenuItem.Comentary.length > 0)
                lines.push(`[${this.MenuItem.Comentary}]`);

            if (lines.length > 0)
            {
                for (let index = 0; index < lines.length; index++) 
                {
                    const line = lines[index];
                    
                    text += `${line}${lines.length - 1 == index ? "" : "\n"}`;
                }
            }
            else
                text += '';
        }
        else if (this.MenuItem.Comentary.length > 0)
            text += `[${this.MenuItem.Comentary}]`;
        else
            text += '';

        return text;
    }

    public get Tags()
    {
        var tags = new Array<string>();

        if(this.MenuItem.Tags !== undefined)
        {
            for (let index = 0; index < this.MenuItem.Tags.length; index++) 
            {
                const tag = this.MenuItem.Tags[index];

                tags.push(tag);
            }
        }

        return tags;
    }

    public getValidation()
    {
        for (let index = 0; index < this.DetailGroupPacks.length; index++) 
        {
            const detailGroupPack = this.DetailGroupPacks[index];
            
            if(detailGroupPack.getValidation() === false)
                return false;
        }

        return true;
    }

    public GetFirstOptionalMessage()
    {
        var messageList = new Array<string>();

        for (let index = 0; index < this.DetailGroupPacks.length; index++) 
        {
            const detailGroupPack = this.DetailGroupPacks[index];
            
            if(detailGroupPack.getValidation() === false)
                messageList.push(detailGroupPack.DetailGroup.Description);
        }

        if (messageList.length > 0)
            return messageList[0];
        else
            return "";
    }

    public getMacroPacks(macroID:string)
    {
        return this.DetailGroupPacks.filter(x => x.DetailGroup.LimitMacroSelection && x.DetailGroup.MacroID === macroID);
    }

    public getMacroSelectionCount(macroID:string)
    {
        var macroPacks = this.getMacroPacks(macroID);

        if(macroPacks.length > 0)
        {
            var macroCount = 0;

            for (let index = 0; index < macroPacks.length; index++) 
            {
                const element = macroPacks[index];
                
                macroCount += element.getSelectionCount();
            }

            return macroCount;
        }

        return 0;
    }

    public isMacroMaxedOut(macroID:string)
    {
        var macroPack = this.DetailGroupPacks.find(x => x.DetailGroup.LimitMacroSelection && x.DetailGroup.MacroID === macroID);

        if(macroPack)
        {
            var maxMacroCount = macroPack.DetailGroup.MacroMaxSelectionCount;
            var macroCount = this.getMacroSelectionCount(macroID);

            return maxMacroCount === macroCount;
        }

        return false;
    }

    public isMacroOkay(macroID:string)
    {
        var macroPack = this.DetailGroupPacks.find(x => x.DetailGroup.LimitMacroSelection && x.DetailGroup.MacroID === macroID);

        if(macroPack)
        {
            var minMacroCount = macroPack.DetailGroup.MacroMinSelectionCount;
            var macroCount = this.getMacroSelectionCount(macroID);

            return macroCount >= minMacroCount;
        }

        return true;
    }

    public checkMacro()
    {
        var macros = new Set(( this.DetailGroupPacks.map(obj => obj.DetailGroup.MacroID)));

        macros.delete('');

        if(macros.size === 0)
            return true;

        var status = true;
        
        macros.forEach(x =>
        {
            if(this.isMacroOkay(x) !== true)
                status = false;
        });

        return status;
    }
}
